import { render, staticRenderFns } from "./appHeader.vue?vue&type=template&id=313137ea&scoped=true"
import script from "./appHeader.vue?vue&type=script&lang=js"
export * from "./appHeader.vue?vue&type=script&lang=js"
import style0 from "./appHeader.vue?vue&type=style&index=0&id=313137ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313137ea",
  null
  
)

export default component.exports